import { render, staticRenderFns } from "./AssessmentExercise.vue?vue&type=template&id=c97feab2"
import script from "./AssessmentExercise.vue?vue&type=script&lang=js"
export * from "./AssessmentExercise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports